import React from 'react';
import { useLanguage } from '../../context/LanguageProvider/LanguageProvider';

const PARTNER_LOGOS = [
  { src: '/images/primalogo.png', altKey: 'dataDriven.partners.altPrima' },
  { src: '/images/union.png', altKey: 'dataDriven.partners.altEu' },
  { src: '/images/interreg.jpg.png', altKey: 'dataDriven.partners.altInterreg' },
  { src: '/images/agence-national-de-recherche.jpg', altKey: 'dataDriven.partners.altAnr' },
  { src: '/images/ministere-economie.jpg', altKey: 'dataDriven.partners.altMinEconomie' },
  { src: '/images/bpifrance.jpg', altKey: 'dataDriven.partners.altBpi' },
];

export default function PartnersLogos({
  showHeading = true,
  headingKey = 'dataDriven.partners.h3',
  showLead = true,
  className = '',
  id,
  leadClassName = 'fs-18 text-gray-700 mb-0',
}) {
  const { t } = useLanguage();

  return (
    <div id={id} className={`jassp-partners ${className}`.trim()}>
      {showHeading && (
        <div className="text-center mb-4 mb-lg-5">
          <h2 className="h2 mb-2">{t(headingKey)}</h2>
          {showLead ? <p className={leadClassName}>{t('dataDriven.partners.lead')}</p> : null}
        </div>
      )}
      <div className="jassp-partners-logos d-flex flex-nowrap flex-lg-wrap align-items-center justify-content-lg-center gap-4 gap-lg-5 px-2">
        {PARTNER_LOGOS.map((logo) => {
          if (logo.labelKey) {
            return (
              <div
                key={logo.labelKey}
                className="jassp-partners-logo-item jassp-partners-logo-item--text flex-shrink-0 d-flex align-items-center justify-content-center"
              >
                <span className="jassp-partners-logo-text">{t(logo.labelKey)}</span>
              </div>
            );
          }

          return (
            <div key={logo.src} className="jassp-partners-logo-item flex-shrink-0">
              <img
                src={logo.src}
                alt={t(logo.altKey)}
                className="jassp-partners-logo-img"
                loading="lazy"
                decoding="async"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
